<ng-container *ngIf="reportData && reportData.brokerStoreDetails">
  <div *ngIf="forPdf" class="page-break-before"></div>

  <style>
    .broker-report-container table.data-table { font-size: 10px !important; width: 100% !important; }
    .broker-report-container table.data-table th, 
    .broker-report-container table.data-table td { padding: 4px 4px !important; }
    .broker-report-container table.data-table th { font-size: 11px !important; }
  </style>

  <div class="card main-card broker-report-container" [class.mt-1-5]="!forPdf">
    <h3 class="section-title" [class.mt-0]="!forPdf" [style.margin-top]="forPdf ? '0' : null">
      Store Details for {{ reportData.companyName }}
    </h3>
    <table class="data-table">
      <thead>
        <tr>
          <th rowspan="2" class="text-left" style="vertical-align: bottom;">Store Name</th>
          <th rowspan="2" class="text-left" style="vertical-align: bottom;">Store ID</th>
          <th [colSpan]="reportData.brokerStoreDetails.rates.length + 1" class="text-center">Revenue</th>
          <th [colSpan]="reportData.brokerStoreDetails.rates.length + 1" class="text-center fee-col">SMRS Fees</th>
        </tr>
        <tr>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right">{{ rate.name }}</th>
          <th class="text-right">Total Revenue</th>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right fee-col">{{ rate.name }}<br><span style="font-size: 0.85em; font-weight: normal;">({{ rate.rate }}%)</span></th>
          <th class="text-right fee-col">Total Fee</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let store of reportData.brokerStoreDetails.stores" class="pdf-row">
          <td class="text-left">{{ store.storeName }}</td>
          <td class="text-left">{{ store.storeId }}</td>
          <td *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right">{{ store.revenues[rate.name] | currency }}</td>
          <td class="text-right fw-600">{{ store.totalRevenue | currency }}</td>
          <td *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right fee-col">({{ store.fees[rate.name] | currency }})</td>
          <td class="text-right fw-600 fee-col">({{ store.totalFee | currency }})</td>
        </tr>
        <tr *ngIf="reportData.brokerStoreDetails.stores.length === 0">
          <td [attr.colspan]="reportData.brokerStoreDetails.rates.length * 2 + 4" class="text-center empty-table-msg">No store data available.</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="2" class="text-left">Total</th>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right">{{ reportData.brokerStoreDetails.totals.revenues[rate.name] | currency }}</th>
          <th class="text-right">{{ reportData.brokerStoreDetails.totals.totalRevenue | currency }}</th>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right fee-col">({{ reportData.brokerStoreDetails.totals.fees[rate.name] | currency }})</th>
          <th class="text-right fee-col">({{ reportData.brokerStoreDetails.totals.totalFee | currency }})</th>
        </tr>
        <tr *ngIf="reportData.isInternational">
          <th colspan="2" class="text-left">Total (USD) <span class="rate-note">(Rate: {{ reportData.exchangeRate | number:'1.4-4' }})</span></th>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right">{{ (reportData.brokerStoreDetails.totals.revenues[rate.name] * (reportData.exchangeRate || 1)) | currency:'USD' }}</th>
          <th class="text-right">{{ (reportData.brokerStoreDetails.totals.totalRevenue * (reportData.exchangeRate || 1)) | currency:'USD' }}</th>
          <th *ngFor="let rate of reportData.brokerStoreDetails.rates" class="text-right fee-col">({{ (reportData.brokerStoreDetails.totals.fees[rate.name] * (reportData.exchangeRate || 1)) | currency:'USD' }})</th>
          <th class="text-right fee-col">({{ (reportData.brokerStoreDetails.totals.totalFee * (reportData.exchangeRate || 1)) | currency:'USD' }})</th>
        </tr>
      </tfoot>
    </table>
  </div>
</ng-container>
